import type { KeyValueType } from '../types/KeyValueType';

/**
 * checks either if the object contains at least 1 value or not
 * @param obj object to check
 * @param valuesToCheck values to check for
 * @param defaultValue default value to return if the valuesToCheck is empty
 * @returns true if contains at least 1 value, false otherwise
 */
export const checkIfObjectContainsAtLeastOneValue = (
  obj: Record<string, unknown>,
  valuesToCheck?: KeyValueType[],
  defaultValue = false,
): boolean => {
  if (!valuesToCheck || valuesToCheck.length == 0) {
    return defaultValue;
  }
  for (const { key, value } of valuesToCheck) {
    if (obj[key] === value) {
      return true;
    }
  }
  return false;
};
